export default {
  /**
   * Transforms a text so it's safe to be used as an identifier name.
   * Removes any special characters and also numbers at beginning of text.
   * Useful for code generators.
   */
  toIdentifierCase(text: string, casing: 'camelCase' | 'pascalCase' = 'camelCase') {
    let casedText = text
      .replace(/^[0-9]+/, ''); // identifiers can't start with a number
    if (casing === 'camelCase') {
      casedText = this.toCamelCase(casedText);
    } else {
      casedText = this.toPascalCase(casedText);
    }
    return casedText
      .replace(/ö/g, 'oe')
      .replace(/ä/g, 'ae')
      .replace(/ü/g, 'ue')
      .replace(/Ö/g, 'Oe')
      .replace(/Ä/g, 'Ae')
      .replace(/Ü/g, 'Ue')
      .replace(/è/g, 'e')
      .replace(/é/g, 'e')
      .replace(/ë/g, 'e')
      .replace(/ç/g, 'c')
      .replace(/[\W]/g, '');
  },
  /** Transforms text to title case (```'A string-Example' => 'A String Example'```) */
  toTitleCase(text: string) {
    return text
      .toLowerCase()
      .replace(/[^A-Za-z0-9\r\n\u00C0-\u02AF]+[A-Za-z\u00C0-\u02AF]/g, (match) => ` ${match.slice(-1).toUpperCase()}`)
      .replace(/^./, (match) => match.toUpperCase());
  },
  /** Transforms text to screaming snake case (```'A string-Example' => 'A_STRING_EXAMPLE'```) */
  toScreamingSnakeCase(text: string) {
    return this.toSnakeCase(text).toUpperCase();
  },
  /** Transforms text to snake case (```'A string-Example' => 'a_string_example'```) */
  toSnakeCase(text: string) {
    return text
      .toLowerCase()
      .replace(/[^A-Za-z0-9\r\n\u00C0-\u02AF]+[A-Za-z\u00C0-\u02AF]/g, (match) => `_${match.slice(-1)}`);
  },
  /** Transforms text to screaming kebab case (```'A string-Example' => 'A-STRING-EXAMPLE'```) */
  toScreamingKebabCase(text: string) {
    return this.toKebabCase(text).toUpperCase();
  },
  /** Transforms text to kebab case (```'A string-Example' => 'a-string-example'```) */
  toKebabCase(text: string) {
    return text
      .toLowerCase()
      .replace(/[^A-Za-z0-9\r\n\u00C0-\u02AF]+[A-Za-z\u00C0-\u02AF]/g, (match) => `-${match.slice(-1)}`);
  },
  /** Transforms text to camel case (```'A string-Example' => 'aStringExample'```) */
  toCamelCase(text: string) {
    return text
      .replace(/(^[A-Z\u00C0-\u02AF]+(?=[A-Z]*[A-Z]))|(^.)/g, (match) => match.toLowerCase())
      .replace(/[^A-Za-z0-9\r\n\u00C0-\u02AF]+[A-Za-z\u00C0-\u02AF]/g, (match) => {
        return match.slice(-1).toUpperCase();
      });
  },
  /** Transforms text to pascal case (```'A string-Example' => 'AStringExample'```) */
  toPascalCase(text: string) {
    return text.replace(/^[a-z]|[^A-Za-z0-9\r\n\u00C0-\u02AF]+[A-Za-z\u00C0-\u02AF]/g, (match) => {
      return match.slice(-1).toUpperCase();
    });
  },
};
